import React, { useState, useEffect, useRef } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { submitUpdateThunk } from "../../Redux/thunks/updateThunks";
import { RESET_ALL_STATES, setAuthenticated } from "../../Redux/actions/actions";
import Navigation from "../../Components/Nav/Navigation";
import ButtonDropDown from "../../Components/buttonDropDown";
import { useTranslation } from "react-i18next";

const PhoneUpdate = () => {
    const { t } = useTranslation();
    const uniqueIdObject = useSelector((state) => state.uin);
    const faceAuthData = useSelector((state) => state.faceAuth.data);
    const faceData = useSelector((state) => state.faceAuth.data);
    const [updatedDTO, setUpdatedDTO] = useState({
        fullName: { eng: "", amh: "" },
        gender: { eng: "", amh: "" },
        woreda: { eng: "", amh: "" },
        zone: { eng: "", amh: "" },
        region: { eng: "", amh: "" },
        residenceStatus: { eng: "", amh: "" },
        dateOfBirth: "",
        phone: "",
        email: "",
        uin: "",
        proofOfAddress: "",
        individualBiometrics: "",
        proofOfIdentity: "",
        idschemaVersion: "",
        documentOne: {},
        documentTwo: {},
        photo: "",
    });
    const submitResponse = useSelector((state) => state.update);
    const [pdfModal, setPdfModal] = useState(false);
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const isLoading = useSelector((state) => state.otp.isLoading);
    const isResponseError = useSelector((state) => state.otp.error);
    const data = useSelector((state) => state.otp.data);
    const [isSubmitDisabled, setIsSubmitDisabled] = useState(false);
    const [error, setError] = useState(null);
    const firstInputRef = useRef(null);
    const [resendTime, setResendTime] = useState(null);
    const timeoutDuration = 30;
    const [phone, setPhone] = useState("");

    useEffect(() => {
        const storedData = uniqueIdObject;

        if (faceAuthData) {
            const updatedState = {
                fullName: {
                    eng: faceAuthData.fullName?.eng || "",
                    amh: faceAuthData.fullName?.amh || "",
                },
                gender: {
                    eng: faceAuthData.gender?.eng || "",
                    amh: faceAuthData.gender?.amh || "",
                },
                woreda: {
                    eng: faceAuthData.woreda?.eng || "",
                    amh: faceAuthData.woreda?.amh || "",
                },
                zone: {
                    eng: faceAuthData.zone?.eng || "",
                    amh: faceAuthData.zone?.amh || "",
                },
                region: {
                    eng: faceAuthData.region?.eng || "",
                    amh: faceAuthData.region?.amh || "",
                },
                residenceStatus: {
                    eng: faceAuthData.residenceStatus?.eng || "",
                    amh: faceAuthData.residenceStatus?.amh || "",
                },
                dateOfBirth: faceAuthData.dateOfBirth || "",
                phone: faceAuthData.phone || "",
                email: faceAuthData.email || "",
                uin: faceAuthData.uin || "",
                proofOfAddress: faceAuthData.proofOfAddress || "",
                individualBiometrics: faceAuthData.individualBiometrics || "",
                proofOfIdentity: faceAuthData.proofOfIdentity || "",
                idschemaVersion: faceAuthData.idschemaVersion || "",
                documentOne: faceAuthData.documents?.[0] || "",
                documentTwo: faceAuthData.documents?.[1] || "",
                photo: faceAuthData.photo || "",
            };

            setUpdatedDTO(updatedState);
        } else if (storedData) {
            const setupdatedState = {
                fullName: {
                    eng: storedData.fullName?.eng || "",
                    amh: storedData.fullName?.amh || "",
                },
                gender: {
                    eng: storedData.gender?.eng || "",
                    amh: storedData.gender?.amh || "",
                },
                woreda: {
                    eng: storedData.woreda?.eng || "",
                    amh: storedData.woreda?.amh || "",
                },
                zone: {
                    eng: storedData.zone?.eng || "",
                    amh: storedData.zone?.amh || "",
                },
                region: {
                    eng: storedData.region?.eng || "",
                    amh: storedData.region?.amh || "",
                },
                residenceStatus: {
                    eng: storedData.residenceStatus?.eng || "",
                    amh: storedData.residenceStatus?.amh || "",
                },
                dateOfBirth: storedData.dateOfBirth || "",
                phone: storedData.phone || "",
                email: storedData.email || "",
                uin: storedData.uin || "",
                proofOfAddress: storedData.proofOfAddress || "",
                individualBiometrics: storedData.individualBiometrics || "",
                proofOfIdentity: storedData.proofOfIdentity || "",
                idschemaVersion: storedData.idschemaVersion || "",
                documentOne: {
                    category: storedData?.documentOne?.category || "",
                    value: storedData.documentOne?.value || "",
                },
                documentTwo: {
                    category: storedData?.documentTwo?.category || "",
                    value: storedData.documentTwo?.value || "",
                },
                photo: storedData.photo || "",
            };

            setUpdatedDTO(setupdatedState);
        }
    }, [faceAuthData]);

    const updateField = (fieldName, newValue) => {
        setUpdatedDTO({
            ...faceAuthData,
            [fieldName]: newValue,
        });
    };

    useEffect(() => {
        updateField("phone", `${phone}`);
    }, [phone]);

    useEffect(() => {
        if (firstInputRef.current) {
            firstInputRef.current.focus();
        }
    }, []);

    useEffect(() => {
        if (data) {
            dispatch(setAuthenticated());
            dispatch({ type: "LOGIN" });
            navigate("/dashboard");
        }
    }, [data, dispatch, navigate]);

    const handleSubmit = async (event) => {
        event.preventDefault();

        setIsSubmitDisabled(true);
        setPdfModal(true);
        try {
            await dispatch(
                submitUpdateThunk(
                    updatedDTO,
                    faceAuthData.uin,
                    "FIN",
                    "",
                    true
                )
            ).finally(() => setIsSubmitDisabled(false));
        } catch (error) {
            console.error("Error occurred during dispatch:", error);
                    setIsSubmitDisabled(false);

        }
    };

    useEffect(() => {
        if (!resendTime) return;

        const timer = setInterval(() => {
            const elapsed = Math.floor((Date.now() - resendTime) / 1000);
            if (elapsed >= timeoutDuration) {
                clearInterval(timer);
                setResendTime(null);
            }
        }, 1000);

        return () => clearInterval(timer);
    }, [resendTime, timeoutDuration]);

    const closeModal = () => {
        setPdfModal(false);
    };

    const handleChangePhoneNumber = (e) => {
        const value = e.target.value.replace(/\D/g, "");
        if (value.length <= 10) {
            setPhone(value);
        }
    };

    useEffect(() => {
        if (faceData) {
            navigate("/phoneUpdate");
        }
        else {
            navigate("/");
        }
    }, []);

    return (
        <div className='relative bg-[whitesmoke] flex flex-col overflow-y-hidden scrollbar-hide h-screen pb-14 md:pb-[6%] md:px-[%] z-0 items-center justify-center bg-cover bg-opacity-6 font-barlow pt-14'>
            {pdfModal &&
                (submitResponse.isLoading ? (
                    <div
                        className='fixed inset-0 z-50 flex items-center justify-center bg-black/70 p-4 backdrop-blur-sm transition-all duration-500 w-full h-full'
                        onClick={() => {
                            // closeModal();
                            // navigate(`/${user}/`);
                        }}
                    >
                        <div className='z-50 flex'>
                            <p className='text-2xl font-bold uppercase text-white opacity-100 '>
                                Loading...
                            </p>
                        </div>
                    </div>
                ) : submitResponse.error ? (
                    <div
                        className='fixed inset-0 z-50 flex items-center justify-center bg-black/70 p-4 backdrop-blur-sm transition-all duration-500 w-full h-full'
                        onClick={() => {
                            // closeModal();
                            navigate("/");
                        }}
                    >
                        <div className='z-50 flex'>
                            <p className='text-2xl font-bold uppercase text-white opacity-100 brightness-110 '>
                                error: {submitResponse.error}
                            </p>
                        </div>
                    </div>
                ) : submitResponse.data ? (
                    <div
                        className='fixed inset-0 z-50 flex items-center justify-center bg-black/70 p-4 backdrop-blur-sm transition-all duration-500 w-full h-full'
                        onClick={() => {
                            closeModal();
                            navigate("/");
                        }}
                    >
                        <div className='bg-white rounded-xl shadow-lg w-full max-w-md mx-4 flex flex-col items-center p-2'>
                            <div className='flex justify-end w-full'>
                                <button
                                    className='px-4 py-1 text-white bg-darkred rounded-xl'
                                    onClick={() => {
                                        closeModal();
                                        navigate("/");
                                    }}
                                >
                                    X
                                </button>
                            </div>
                            <h2 className='text-2xl font-semibold underline text-nidblue underline-offset-2'>
                                Request Message
                            </h2>
                            <p className='text-xl font-semibold text-MetallicBlue text-center'>
                                Your update request has been submitted
                                successfully!
                            </p>
                            <div className='w-12 h-12 flex items-center justify-center'>
                                <svg
                                    xmlns='http://www.w3.org/2000/svg'
                                    viewBox='0 0 24 24'
                                    fill='none'
                                    stroke='#008000'
                                    strokeWidth='2'
                                    strokeLinecap='round'
                                    strokeLinejoin='round'
                                    className='w-full h-full'
                                >
                                    <path d='M22 11.08V12a10 10 0 1 1-5.93-9.14'></path>
                                    <polyline points='22 4 12 14.01 9 11.01'></polyline>
                                </svg>
                            </div>
                        </div>
                    </div>
                ) : (
                    ""
                ))}

            <Navigation />
            <div className='relative flex flex-col z-0 items-center justify-center bg-cover bg-opacity-6 font-barlow   '>
                {/* <div className='bg-slid w-full h-full absolute top-0 left-0 z-10 bg-cover'>
                    {" "}
                </div> */}
                {/* <div className="relative flex w-full z-50  justify-end  bg-nidblue/20 "><ButtonDropDown /> </div> */}
                {/* <div className="relative flex w-full z-50  justify-end  bg-nidblue/20 " /> </div> */}

                <div className='h-fit'>
                    <div className='flex flex-col-reverse md:flex-row gap-5 items-center max-w-[1200px] mx-auto'>
                        <div className='relative flex flex-col md:flex z-40 md:flex-row md:h-full justify-center w-full px-3'>
                            <div className='w-full shadow-md rounded-md overflow-clip'>
                                {/* The title */}
                                <div className='bg-nidblue md:p-3 rounded-t-md'>
                                    <h2 className='py-2 text-sm font-bold text-center text-white md:py-0 md:text-base'>
                                        {t("please-enter-phone-number")}
                                    </h2>
                                </div>

                                {/* Everything below */}
                                <div className=' bg-faydagrey bg-gradient-to-b p-4 md:px-[10%] pt-[6%] md:pt-[5%]'>
                                    <form
                                        onSubmit={handleSubmit}
                                        className='md:space-y-6 space-y-4 '
                                        // className="space-y-1 md:space-y-0 g-green-500"
                                    >
                                        <div className='flex gap-3 py-1 justify-evenly  md:py-0'>
                                            <input
                                                className={`text-xl md:p-0 px-2 text-center rounded form-control bg-faydagrey ${
                                                    data
                                                        ? "border-nidyellow/40 border-2 focus:border-transparent focus:border-2 focus:border-nidyellow/20"
                                                        : " border-gray-400 border"
                                                }`}
                                                type='text'
                                                name='phone'
                                                maxLength='10'
                                                minLength='10'
                                                value={phone}
                                                onChange={(e) =>
                                                    handleChangePhoneNumber(e)
                                                }
                                                onFocus={(e) =>
                                                    e.target.select()
                                                }
                                                required
                                            />
                                            {data && (
                                                <div className='input-ring absolute top-0 left-0 right-0 bottom-0 border-2 rounded-full animate-input-ring'></div>
                                            )}
                                        </div>
                                        {error && (
                                            <div className='text-red-500 flex justify-center mt-2'>
                                                {error}
                                            </div>
                                        )}{" "}
                                        <div className='flex justify-center items-center mt-8'>
                                            <button
                                                type='submit'
                                                disabled={
                                                    isSubmitDisabled ||
                                                    isLoading
                                                }
                                                className='z-50 px-16 md:px-12 py-2.5 md:py-2 text-white bg-nidblue rounded-lg shadow hover:bg-nidyellow duration-300 focus:outline-none'
                                            >
                                                {isLoading
                                                    ? t("loading")
                                                    : t("submit")}
                                            </button>
                                        </div>
                                        {isResponseError && (
                                            <div className='text-red-500 flex justify-center mt-2'>
                                                {isResponseError?.message && (
                                                    <p>{t("otp-error-text")}</p>
                                                )}
                                            </div>
                                        )}
                                    </form>
                                </div>
                            </div>
                        </div>

                        <div className='flex flex-col text-black w-full items-center justify-center text-bold font-barlow b-nidgreen md:text-lg text-sm bg-500 text-justify md:mt-0 mt-'>
                            <div className=''>
                                <div className='flex flex-col w-full h-auto b text-black p-8 items-center justify-center '>
                                    <p className='text-3xl font-extrabold pt-10 pb-8 text-center'>
                                        <span className='text-nidyellow font-semi-bold'>
                                            Welcome
                                        </span>{" "}
                                        to the Fayda{" "}
                                        <span className='text-nidyellow font-semi-bold'>
                                            Resident
                                        </span>{" "}
                                        Portal!
                                    </p>
                                    <p className=' px-4 text-center leading-relaxed'>
                                        Here, you can effortlessly manage your
                                        identity details, enroll for services,
                                        and update your personal information
                                        with just a few clicks. Enjoy convenient
                                        access to a world of services, tailored
                                        just for you. Your digital journey is
                                        safe with us. Let's get started on
                                        enhancing your digital identity
                                        experience!
                                    </p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default PhoneUpdate;
